export default __webpack_public_path__ + "static/Ship correctly-66c5d5ca7835e00ff9ca7a3b7b47710e.png";